import { ApplicationConfig, provideZoneChangeDetection, isDevMode, APP_INITIALIZER, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { provideServiceWorker } from '@angular/service-worker';
import { ApmErrorHandler, ApmModule, ApmService, APM } from '@elastic/apm-rum-angular';
import { apm } from '@elastic/apm-rum';
import { initApm } from '../apmInitilize';
export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideToastr(), provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    importProvidersFrom(ApmModule),

    // APM required providers
    { provide: APM, useValue: apm },
    { provide: ErrorHandler, useClass: ApmErrorHandler },
    { provide: APP_INITIALIZER, useFactory: initApm, deps: [ApmService], multi: true },
  ]
};
